<template>
  <div class="container container-shadow login-container reset-container">
      <el-form :model="formVal" :rules="formRules" ref="formVal" class="login-box">
        <div class="reset-tips">The account you are retrieving is: {{accountNum}}</div>
        <el-form-item label="Password" prop="pass" class="form-row password-row">
            <div class="btn-show-password" @click="togglePw" :class="{'open':passType==='text'}"></div>
            <el-input :type="passType" v-model="formVal.pass" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Confirm password" prop="checkPass" class="form-row password-row check-pass-row">
            <div class="btn-show-password" @click="toggleCheckPass" :class="{'open':checkPassType==='text'}"></div>
            <el-input :type="checkPassType" v-model="formVal.checkPass"  auto-complete="off"></el-input>
        </el-form-item>
        <div class="form-row form-button">
          <el-button @click="submitForm('formVal')" :loading="isLoading">Confirm</el-button>
        </div> 
      </el-form>
  </div>
</template>

<script>
import { validatePass } from 'utils/validate'
import { resetPassword } from 'service/login'
export default {
  data() {
    let validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again.'))
      } else if (value !== this.formVal.pass) {
        callback(new Error('The   two input password is not consistent!'))
      } else {
        callback()
      }
    }

    return {
      isLoading: false,
      accountNum: decodeURIComponent(this.$route.query.email),
      isDisabled: true,
      passType: 'password',
      checkPassType: 'password',
      formVal: {
        pass: '',
        checkPass: ''
      },
      formRules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validateCheckPass, trigger: 'blur' }]
      }
    }
  },
  created() {
    window.vuex_store.commit('set_title', 'Account Settings')
  },
  methods: {
    togglePw() {
      if (this.passType === 'password') {
        this.passType = 'text'
      } else {
        this.passType = 'password'
      }
    },
    toggleCheckPass() {
      if (this.checkPassType === 'password') {
        this.checkPassType = 'text'
      } else {
        this.checkPassType = 'password'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log('valid', valid)
        if (valid) {
          this.isLoading = true
          resetPassword({
            password: this.formVal.pass,
            code: this.$route.query.code
          })
            .then(res => {
              this.isLoading = false
              this.$router.push({
                name: 'resetPasswordSuccess',
                params: { email: res.email }
              })
            })
            .catch(() => {
              this.isLoading = false
            })
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  },
  watch: {
    formVal: {
      handler(newVal, oldVal) {
        // 是否禁用提交按钮
        this.$refs.formVal.validate(valid => {
          this.isDisabled = !valid
        })
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';

.reset-container {
  height: 364px;
  .reset-tips {
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 1;
  }
  .form-row {
    margin-top: 20px;
    label {
      position: absolute;
      left: 0;
      top: 11px;
      line-height: 30px;
      z-index: 3;
      padding: 0 22px;
      border-right: 1px solid #ccc;
    }
    .el-form-item__error {
      position: absolute;
      right: -250px;
      top: 1px;
      left: auto;
      width: 240px;
      height: 50px;
      border: solid 1px #0A95FF;
      color: #333333;
      font-size: 12px;
      padding: 12px;
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: 19px;
        left: -9px;
        border-width: 6px 8px 6px 0;
        border-style: solid solid solid solid;
        border-color: transparent #0A95FF transparent transparent;
      }
      &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: 19px;
        left: -8px;
        border-width: 6px 8px 6px 0;
        border-style: solid solid solid solid;
        border-color: transparent #fff transparent transparent;
      }
    }
  }

  .password-row input {
    padding-left: 113px;
  }
  .check-pass-row input {
    padding-left: 168px;
  }
}
</style>
